import { ImQrcode } from "react-icons/im";
import { IQrCode } from "../admin/models";
import { useState } from "react";
import QRCodeReact from "react-qr-code";

interface IQRCodePanelProps {
  currentQR?: IQrCode;
  saveQREvent: () => void;
  cancelQREvent: () => void;
  isSaving?: boolean;
  updateQRLongitude: (value: number) => void;
  updateQRLatitude: (value: number) => void;
  updateQRAltitude: (value: number) => void;
  updateQRHeading: (value: number) => void;
  setPutQREnabled: (enabled: boolean) => void;
}

export const QRCodePanel = (props: IQRCodePanelProps) => {
  const {
    currentQR,
    saveQREvent,
    cancelQREvent,
    updateQRLongitude,
    updateQRLatitude,
    updateQRAltitude,
    updateQRHeading,
    setPutQREnabled,
    isSaving,
  } = props;

  const [isQREnabled, setIsQREnabled] = useState(false);

  const togglePutQREnabled = () => {
    setIsQREnabled(!isQREnabled);
    setPutQREnabled(!isQREnabled);
  };

  return (
    <>
      <h3>QR Code</h3>

      <div className="flex flex-wrap justify-evenly">
        <button
          className="flex flex-col content-center justify-center p-2"
          type="button"
          onClick={togglePutQREnabled}
        >
          <ImQrcode className="text-4xl mx-auto mb-1" />
          <span className="text-xs">Place: {isQREnabled ? "ON" : "OFF"}</span>
        </button>
      </div>
      {currentQR && (
        <div>
          <h4>ID</h4>
          <p className="text-xs mb-4">{currentQR.id}</p>
          <h4>Longitude</h4>
          <div className="flex content-center justify-between">
            <p className="flex flex-wrap content-center text-xs">
              {currentQR.longitude}
            </p>
            <div>
              <button
                className="text-xs w-6 m-1 px-1 bg-white text-black rounded-sm"
                type="button"
                onClick={() => updateQRLongitude(-0.00001)}
              >
                --
              </button>
              <button
                className="text-xs w-6 m-1 px-1 bg-white text-black rounded-sm"
                type="button"
                onClick={() => updateQRLongitude(-0.000001)}
              >
                -
              </button>
              <button
                className="text-xs w-6 m-1 px-1 bg-white text-black rounded-sm"
                type="button"
                onClick={() => updateQRLongitude(0.000001)}
              >
                +
              </button>
              <button
                className="text-xs w-6 m-1 px-1 bg-white text-black rounded-sm"
                type="button"
                onClick={() => updateQRLongitude(0.00001)}
              >
                ++
              </button>
            </div>
          </div>
          <h4>Latitude</h4>
          <div className="flex content-center justify-between">
            <p className="flex flex-wrap content-center text-xs">
              {currentQR.latitude}
            </p>
            <div>
              <button
                className="text-xs w-6 m-1 px-1 bg-white text-black rounded-sm"
                type="button"
                onClick={() => updateQRLatitude(-0.00001)}
              >
                --
              </button>
              <button
                className="text-xs w-6 m-1 px-1 bg-white text-black rounded-sm"
                type="button"
                onClick={() => updateQRLatitude(-0.000001)}
              >
                -
              </button>
              <button
                className="text-xs w-6 m-1 px-1 bg-white text-black rounded-sm"
                type="button"
                onClick={() => updateQRLatitude(0.000001)}
              >
                +
              </button>
              <button
                className="text-xs w-6 m-1 px-1 bg-white text-black rounded-sm"
                type="button"
                onClick={() => updateQRLatitude(0.00001)}
              >
                ++
              </button>
            </div>
          </div>
          <h4>Altitude</h4>
          <div className="flex content-center justify-between">
            <p className="flex flex-wrap content-center text-xs">
              {currentQR.altitude}
            </p>
            <div>
              <button
                className="text-xs w-6 m-1 px-1 bg-white text-black rounded-sm"
                type="button"
                onClick={() => updateQRAltitude(-1)}
              >
                --
              </button>
              <button
                className="text-xs w-6 m-1 px-1 bg-white text-black rounded-sm"
                type="button"
                onClick={() => updateQRAltitude(-0.1)}
              >
                -
              </button>
              <button
                className="text-xs w-6 m-1 px-1 bg-white text-black rounded-sm"
                type="button"
                onClick={() => updateQRAltitude(0.1)}
              >
                +
              </button>
              <button
                className="text-xs w-6 m-1 px-1 bg-white text-black rounded-sm"
                type="button"
                onClick={() => updateQRAltitude(1)}
              >
                ++
              </button>
            </div>
          </div>
          <h4>Heading</h4>
          <div className="flex content-center justify-between">
            <p className="flex flex-wrap content-center text-xs">
              {currentQR.heading}
            </p>
            <div>
              <button
                className="text-xs w-6 m-1 px-1 bg-white text-black rounded-sm"
                type="button"
                onClick={() => updateQRHeading(-10)}
              >
                --
              </button>
              <button
                className="text-xs w-6 m-1 px-1 bg-white text-black rounded-sm"
                type="button"
                onClick={() => updateQRHeading(-1)}
              >
                -
              </button>
              <button
                className="text-xs w-6 m-1 px-1 bg-white text-black rounded-sm"
                type="button"
                onClick={() => updateQRHeading(1)}
              >
                +
              </button>
              <button
                className="text-xs w-6 m-1 px-1 bg-white text-black rounded-sm"
                type="button"
                onClick={() => updateQRHeading(10)}
              >
                ++
              </button>
            </div>
          </div>
          <h4>QR Code</h4>
          <div>
            <p className="text-xs">
              <a
                href={`{https://www.foundat.com/app,"ast":0,"la":${currentQR.latitude},"lo":${currentQR.longitude},"a":${currentQR.altitude},"h":${currentQR.heading}}`}
                target="_blank"
              >
                {`{https://www.foundat.com/app,"ast":0,"la":${currentQR.latitude},"lo":${currentQR.longitude},"a":${currentQR.altitude},"h":${currentQR.heading}}`}
              </a>
            </p>
            <QRCodeReact
              size={256}
              value={`{https://www.foundat.com/app,"ast":0,"la":${currentQR.latitude},"lo":${currentQR.longitude},"a":${currentQR.altitude},"h":${currentQR.heading}}`}
              viewBox={`0 0 256 256`}
              className="w-3/5"
            />
          </div>

          <div>
            <button
              className="bg-blue-200 text-slate-800 m-4 p-2 rounded-sm"
              type="button"
              onClick={() => saveQREvent()}
            >
              SAVE POI
            </button>
            <button
              className="bg-red-100 text-slate-800 m-4 p-2 rounded-sm"
              type="button"
              onClick={() => cancelQREvent()}
            >
              CANCEL
            </button>
          </div>
        </div>
      )}
    </>
  );
};
